// @flow
import { createElement } from 'react';
import { injectIntl } from 'react-intl';
import { toFarenheit } from '~/core/utils/temperature';
import { flowRight } from 'lodash/fp';

const CELSIUS = 'C';
const FARENHEIT = 'F';

type Props = {
    value?: number,
    unit: typeof CELSIUS | typeof FARENHEIT,
    element?: string,
    showUnit?: boolean,
    decimalPlaces?: number,
    hideSymbol?: boolean,
    intl: $npm$ReactIntl$IntlShape
};

const removeDecimalZeroes = (num: number) => (num % 1 === 0 ? Math.floor(num) : num);

function Temperature({ value, unit, hideSymbol, showUnit, element = 'span', decimalPlaces = 1, intl }: Props) {
    const transformTemperatureForDisplay = flowRight(intl.formatNumber, removeDecimalZeroes, Number, num =>
        num.toFixed(decimalPlaces)
    );
    let displayValue = '';

    if (!isNaN(parseInt(value, 10))) {
        const temp = unit === CELSIUS ? value : toFarenheit(value);
        displayValue = transformTemperatureForDisplay(temp);
    }

    // $FlowFixMe
    return createElement(element, null, [displayValue, !hideSymbol && '°', showUnit && unit]);
}

export default injectIntl(Temperature);



// WEBPACK FOOTER //
// ./src/components/widgets/temperature/component.js